import React from 'react';
import './section-header.less';
export default class SectionHeader extends React.Component {
  render() {
    const {
      title,
      children
    } = this.props;
    return /*#__PURE__*/React.createElement("div", {
      className: "section-header"
    }, title && /*#__PURE__*/React.createElement("h2", null, /*#__PURE__*/React.createElement("a", {
      href: `#${encodeURIComponent(title).toLowerCase()}`
    }, title)), children);
  }
}
//# sourceMappingURL=section-header.js.map